import React from "react";
import CourseHeader from "../Shared/CourseHeader";
import cyberImg from "../../../assets/cybersecurity solutions.jpeg";

const CyberSecurityHeader = () => {
    return (
        <CourseHeader
            title="Cyber"
            highlight="Security"
            subtitle="Defend. Protect. Secure the Future."
            backgroundImage={cyberImg}
        />
    );
};

export default CyberSecurityHeader;
